export default __webpack_public_path__ + "static/lutein-zeaforce-slider-lifestyle-hd-c3adcfed9f36a24e968a33ae0ee1f269.jpg";